import * as React from 'react';
import { Row } from './Row.js';
import { SubRow } from './SubRow.js';

const TableRows = (props) => {
    const { rows, renderSubComponent, size } = props;
    return rows.map((row) => (React.createElement(React.Fragment, { key: `${row.id}-row` },
        React.createElement(Row, { row: row, size: size }),
        row.getIsExpanded() && renderSubComponent && (React.createElement(SubRow, { key: `${row.id}-subrow` },
            React.createElement("td", { colSpan: row.getVisibleCells().length, className: `h-p-${size}` }, renderSubComponent(row)))))));
};

export { TableRows };
//# sourceMappingURL=TableRows.js.map
